import { FundWithDetailsEntity } from '../../Entities/Fund.WithDetails.Entity';
import { FundApi } from './Fund.FrontEnd.Api.Calls';

export class FundWithDetailsApi extends FundApi {
    protected static _Entity = FundWithDetailsEntity;
}
